import * as React from 'react';
import { Modal } from 'antd';

interface UnsavedChangesModalProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({ open, onStay, onLeave }) => (
  <Modal
    open={open}
    title="Unsaved changes"
    onCancel={onStay}
    onOk={onLeave}
    okText="OK"
    cancelText="Cancel"
    mask={{ closable: false }}
    okButtonProps={{ autoFocus: false }}
    cancelButtonProps={{ autoFocus: true }}
    centered
    keyboard={false}
    zIndex={1100}
  >
    <p>You have unsaved changes. Continue without saving?</p>
  </Modal>
);

export default UnsavedChangesModal;